<template>
  <div>
    <v-layout class="ml-4 mt-4 mr-2">
      <div :class="ui.textHeadline">
        {{this.companyTitle2}} sign up
      </div>
      <v-spacer/>
      <div :class="ui.responseShowXs">
        <v-btn flat icon small :color="ui.btnColor" :to="'/about'">
          <v-icon dark>info_outline</v-icon>
        </v-btn>
      </div>
      <div :class="ui.responseHideXs">
        <v-btn outline small :color="ui.btnColor" :to="'/about'">
          <v-icon dark left>info_outline</v-icon>
          about
        </v-btn>
      </div>
      <div :class="ui.responseShowXs">
        <v-btn flat icon small :color="ui.btnColor" :to="'/signin'">
          <v-icon dark>person</v-icon>
        </v-btn>
      </div>
      <div :class="ui.responseHideXs">
        <v-btn outline small :color="ui.btnColor" :to="'/signin'">
          <v-icon dark left>person</v-icon>
          sign in
        </v-btn>
      </div>
      <div :class="ui.responseShowXs">
        <v-btn flat icon small :color="ui.btnColor" :to="'/'">
          <v-icon dark>home</v-icon>
        </v-btn>
      </div>
      <div :class="ui.responseHideXs">
        <v-btn outline small :color="ui.btnColor" :to="'/'">
          <v-icon dark left>home</v-icon>
          home
        </v-btn>
      </div>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
        <v-card>
          <v-img class="white--text" height="280px"
          :src="require('@/app/assets/images/ship01.jpg')">
            <v-container fill-height fluid>
              <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span :class="ui.textHeadlineLight">sign up </span>
               </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-layout row>
            <v-spacer/>
            <div :class="ui.textImage"> RTM Wakmatha, Copyright © 2018 Rio Tinto. </div>
          </v-layout>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="email"
                label="user email"
                :rules="emailRules"
                prepend-icon="person"
                required
                @keyup.enter="validate"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="enter user password"
                :rules="passwordRules"
                prepend-icon="vpn_key"
                type="password"
                required
                @keyup.enter="validate"
              ></v-text-field>
              <v-text-field
                v-model="confirmedPassword"
                label="confirm user password"
                :rules= "[comparePasswords]"
                prepend-icon="done"
                type="password"
                required
                @keyup.enter="validate"
              ></v-text-field>
              <v-text-field
                v-model="systemPassword"
                label="system password"
                prepend-icon="pin"
                readonly
              ></v-text-field>
              <v-layout row wrap class="mt-4 mb-4">
                <LegalCardPublic v-if="!this.getDataPrivacyAgree"
                :data="{
                  type: 'DP',
                  btnColor: this.ui.btnColor,
                  btnType: 'flat',
                  enableAgreeBtn: true
                  }"/>
                  <LegalCardPublic v-if="!this.getTermsAndCondAgree"
                  :data="{
                    type: 'TC',
                    btnColor: this.ui.btnColor,
                    btnType: 'flat',
                    enableAgreeBtn: true
                    }"/>
              </v-layout>
              <v-layout class="text-xs-left ml-3 mr-2 mt-2"
              v-if="!this.getDataPrivacyAgree">
                <div :class="ui.textSubheading">
                  Please review and agree to Data Privacy Policy to enable sign up application.
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-3 mr-2 mt-2"
              v-if="!this.getTermsAndCondAgree">
                <div :class="ui.textSubheading">
                  Please review and agree to Terms of Use Document to enable sign up application.
                </div>
              </v-layout>
              <v-layout row>
                <v-spacer/>
                <v-layout row class="mt-4">
                  <v-spacer/>
                  <div v-if="enableBtnSpinSignup === false">
                  <v-btn
                    :disabled="
                    !this.getTermsAndCondAgree ||
                    !this.getDataPrivacyAgree ||
                    !valid ||
                    this.getDataPrivacyAgree === false ||
                    this.getTermsAndCondAgree === false
                    "
                    :color="ui.btnColor"
                    @click="validate"
                    flat
                  >
                    <v-icon left> person </v-icon>
                    sign up
                  </v-btn>
                </div>
                <div v-else>
                  <BtnSpin :btnSpec="btnInfo1"/>
                </div>
                </v-layout>
              </v-layout>
              <v-layout row class="mt-4">
                <PublicFooterCard :data="{bkgd: 'white'}"/>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    </v-container>
    <InfoSnackbar/>
  </div>
</template>

<script>
import InfoSnackbar from "@/frame/messages/components/InfoSnackbar";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import createUser from "@/user/auth/mixins/createUser.js";
import formSignup from "@/data/rules/mixins/formSignup.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import LegalCardPublic from "@/admin/general/components/LegalCardPublic";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin,
    InfoSnackbar,
    LegalCardPublic,
    PublicFooterCard
  },
  computed: {
    ...mapGetters(["getDataPrivacyAgree", "getTermsAndCondAgree"])
  },
  beforeMount() {
    this.$store.dispatch("changeDataPrivacyAgree", false);
    this.$store.dispatch("changeTermsAndCondAgree", false);
  },
  mixins: [createUser, formSignup, apptheme, publicGlobals],
  data: () => ({
    valid: true,
    enableBtnSpinSignup: false,
    systemPassword: "System Access Confirmed",
    btnInfo1: {
      color: "red",
      icon: "person",
      name: "add user"
    }
  })
};
</script>
